module.exports = __webpack_public_path__ + "static/san_fransisco-a92e1c40c39260a284722bd8880f8b7f.jpg";